<template>
  <div class="relative">
    <f-a-tabs class="mb-3" v-model="tab" :items="['근로자 위치 현황', '위험구역 설정하기', '위험설비 설정하기']"/>
    <employee-location-map v-if="tab === '근로자 위치 현황'"/>
    <set-danger-region v-if="tab === '위험구역 설정하기'"/>
    <set-danger-equipment v-if="tab === '위험설비 설정하기'"/>
  </div>
</template>
<script>
import FATabs from "@/components/FATabs.vue";
import EmployeeLocationMap from "./EmployeeLocationMap.vue";
import SetDangerRegion from "@/views/project/maps/employee-location/SetDangerRegion.vue";
import SetDangerEquipment from "@/views/project/maps/employee-location/SetDangerEquipment.vue";

export default {
  name: 'ProjectMap',
  components: {
    SetDangerEquipment,
    SetDangerRegion,
    FATabs,
    EmployeeLocationMap
  },
  props: {

  },
  computed: {
  },
  data() {
    return {
      tab: '근로자위치 현황',
    };
  },
  methods: {
  },
  mounted() {
  }
}

</script>

<style scoped lang="scss">
</style>
